var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--icon-fill)",
    d: "M183.333 91.6667H148.583L175.583 64.6667L163.833 52.8334L125 91.6667H108.333V75L147.167 36.1667L135.333 24.4167L108.333 51.4167V16.6667H91.6666V51.4167L64.6666 24.4167L52.8333 36.1667L91.6666 75V91.6667H75L36.1666 52.8334L24.4166 64.6667L51.4166 91.6667H16.6666V108.333H51.4166L24.4166 135.333L36.1666 147.167L75 108.333H91.6666V125L52.8333 163.833L64.6666 175.583L91.6666 148.583V183.333H108.333V148.583L135.333 175.583L147.167 163.833L108.333 125V108.333H125L163.833 147.167L175.583 135.333L148.583 108.333H183.333V91.6667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.17c895d409ed7c8ed1b36f35fbaa6374.svg";
export { ForwardRef as ReactComponent };